import { useState, useEffect, useRef } from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import PortfolioSection from "../components/PortfolioSection";
import ServicesSection from "../components/ServicesSection";
import BabeBoothSection from "../components/BabeBoothSection";
import TestimonialsSection from "../components/TestimonialsSection";
import GiftCardSection from "../components/GiftCardSection";
import ContactSection from "../components/ContactSection";
import BookingSection from "../components/BookingSection";
import Footer from "../components/Footer";

const LandingPage = () => {
  const [isVisible, setIsVisible] = useState({});
  const sectionsRef = useRef({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({
              ...prev,
              [entry.target.id]: true,
            }));
          }
        });
      },
      { threshold: 0.1 }
    );

    const sections = document.querySelectorAll("section[id]");
    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#FDFBF9]" data-testid="landing-page">
      <Header />
      <main>
        <HeroSection />
        <AboutSection isVisible={isVisible.about} />
        <PortfolioSection isVisible={isVisible.portfolio} />
        <ServicesSection isVisible={isVisible.services} />
        <BabeBoothSection isVisible={isVisible.rentals} />
        <TestimonialsSection isVisible={isVisible.testimonials} />
        <GiftCardSection isVisible={isVisible["gift-cards"]} />
        <ContactSection isVisible={isVisible.contact} />
        <BookingSection isVisible={isVisible.booking} />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
